import React from 'react';
import { Link } from 'react-router-dom';
import { FiMoon, FiStar, FiTrendingUp } from 'react-icons/fi';
import './Home.css';

const Home = () => {
  // Debug: varmista että Home renderöityy
  if (process.env.NODE_ENV !== 'production') {
    console.log('Home component rendering');
  }

  return (
    <div className="home">
      <section className="hero">
        <div className="hero-content">
          <div className="hero-badge">EXPLORE THE COSMOS</div>
          <h1>Your Journey into Astrology Awaits</h1>
          <p className="hero-subtitle">
            Discover profound insights and guidance through astrology, tarot, and lunar cycles to elevate your spiritual journey.
          </p>
          <div className="hero-buttons">
            <Link to="/register" className="btn btn-primary btn-large">
              Start Now →
            </Link>
            <Link to="/astrology" className="btn btn-secondary btn-large">
              Explore Astrology
            </Link>
          </div>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Explore Our Comprehensive Astrology and Spiritual Services</h2>
          </div>
          <div className="features-grid">
            <Link to="/astrology" className="feature-card">
              <div className="feature-image astrology-image"></div>
              <div className="feature-content">
                <h3>Astrology Essentials</h3>
                <p>
                  From personalized horoscopes to cosmic calendars, we offer everything you need to align with the stars.
                </p>
                <span className="feature-link">Read More →</span>
              </div>
            </Link>

            <Link to="/astrology-chart" className="feature-card">
              <div className="feature-image astrology-image"></div>
              <div className="feature-content">
                <h3>Syntymäkartta &amp; yhteensopivuus</h3>
                <p>
                  Personallisuusanalyysi, syntymäkartan raportti ja yhteensopivuus kahden merkin välillä.
                </p>
                <span className="feature-link">Avaa työkalut →</span>
              </div>
            </Link>

            <Link to="/tarot" className="feature-card">
              <div className="feature-image tarot-image"></div>
              <div className="feature-content">
                <h3>Tarot & Beyond</h3>
                <p>
                  Experience the magic of tarot at your own pace with our intuitive tools and guided resources.
                </p>
                <span className="feature-link">Read More →</span>
              </div>
            </Link>

            <Link to="/moon-phases" className="feature-card">
              <div className="feature-image moon-image"></div>
              <div className="feature-content">
                <h3>Lunar Cycle & Moon Guides</h3>
                <p>
                  Learn how each lunar phase influences your energy, intentions, and growth.
                </p>
                <span className="feature-link">Read More →</span>
              </div>
            </Link>
          </div>
        </div>
      </section>

      <section className="about-section">
        <div className="container">
          <div className="about-content">
            <h2>Kuka olen</h2>
            <p>
              Astral Moon Magic luotiin jakamaan voimaannuttavia resursseja niille, 
              jotka kulkevat henkistä polkuaan. Astrologian ja mystisten taiteiden 
              kautta missiomme on auttaa muita yhdistymään sisäiseen magiaansa ja 
              kosmoksen viisauttaan.
            </p>
            <p>
              Liity matkallemme ja löydä oivalluksia, joita tarvitset kohdataksesi 
              tähtien energiat.
            </p>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <h2>Aloita henkilökohtainen astrologinen matkasi</h2>
          <p>Rekisteröidy nyt ja saa pääsy kaikkiin ominaisuuksiin</p>
          <Link to="/register" className="btn btn-primary btn-large">
            Rekisteröidy ilmaiseksi
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
